// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var a = 1664525;
var c = 1013904223;
var m = 4294967296; // 2^32
export default function () {
    var s = 1;
    return function () { return (s = (a * s + c) % m) / m; };
}
